import { Component, Inject, Input, Optional, ViewChildren, HostBinding } from '@angular/core';
import { RTL } from '@progress/kendo-angular-l10n';
import { SliderUtil as Util } from '@telerik/kendo-inputs-common';
/**
 * @hidden
 */
var SliderTick = /** @class */ (function () {
    function SliderTick(value) {
        this.value = value;
        this.classes = {
            'k-tick': true
        };
    }
    return SliderTick;
}());
/* tslint:disable:component-selector */
/**
 * @hidden
 */
var SliderTicksComponent = /** @class */ (function () {
    function SliderTicksComponent(rtl) {
        this.rtl = rtl;
        this.wrapperClasses = 'k-reset k-slider-items';
        this.ticks = [];
    }
    SliderTicksComponent.prototype.ngOnChanges = function (_) {
        this.createTicks();
    };
    SliderTicksComponent.prototype.createTicks = function () {
        var count = Util.calculateTicksCount(this.max, this.min, this.step);
        var tickValueProps = {
            min: this.min,
            max: this.max,
            smallStep: this.step
        };
        var result = [];
        for (var i = 0; i < count; i++) {
            result.push(new SliderTick(Util.calculateValueFromTick(i, tickValueProps)));
        }
        if (this.rtl || this.vertical) {
            result = result.reverse();
        }
        if (result.length > 0) {
            Object.assign(result[0].classes, this.endTickClasses(true));
            Object.assign(result[result.length - 1].classes, this.endTickClasses(false));
        }
        this.ticks = result;
    };
    SliderTicksComponent.prototype.endTickClasses = function (first) {
        return {
            'k-first': (first && !this.vertical) || (!first && this.vertical),
            'k-last': (!first && !this.vertical) || (first && this.vertical)
        };
    };
    SliderTicksComponent.decorators = [
        { type: Component, args: [{
                    selector: '[kendoSliderTicks]',
                    template: "\n    <li #tickElement *ngFor=\"let tick of ticks;\"\n        [ngClass]=\"tick.classes\"\n        title=\"{{ tickTitle(tick.value) }}\"\n        role=\"presentation\"\n     >&nbsp;</li>\n  "
                },] },
    ];
    /** @nocollapse */
    SliderTicksComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [RTL,] },] },
    ]; };
    SliderTicksComponent.propDecorators = {
        'wrapperClasses': [{ type: HostBinding, args: ['class',] },],
        'tickTitle': [{ type: Input },],
        'vertical': [{ type: Input },],
        'step': [{ type: Input },],
        'min': [{ type: Input },],
        'max': [{ type: Input },],
        'tickElements': [{ type: ViewChildren, args: ['tickElement',] },],
    };
    return SliderTicksComponent;
}());
export { SliderTicksComponent };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-inputs/dist/es/slider/slider-ticks.component.js
// module id = ../../../../@progress/kendo-angular-inputs/dist/es/slider/slider-ticks.component.js
// module chunks = vendor